import { render, staticRenderFns } from "./LandingPageView.vue?vue&type=template&id=cfef00dc&"
import script from "./LandingPageView.vue?vue&type=script&lang=js&"
export * from "./LandingPageView.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageView.vue?vue&type=style&index=0&id=cfef00dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports